import React, { useEffect } from "react";

import Seta from "../../../../Assets/images/seta.png";

import {
	Document,
	Font,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";

import Roboto from "../../../../Assets/fonts/Roboto-Bold.ttf";

import { useState } from "react";
import { VendaService } from "../../../../service/venda_service";

Font.register({
	family: "Roboto bold",
	format: "truetype",
	src: Roboto,
});

const styles = StyleSheet.create({
	page: {
	},
	body: {
		paddingLeft: "5px",
		paddingRight: "5px",
		width: "100%",
		height: "auto",
		backgroundColor: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flex: 1,
		paddingBottom: "2px",
	},
	containerText: {
		marginBottom: "1px",
		maxWidth: "120px"
	},
	containerTitleText: {
		marginBottom: "2px",
		maxWidth: "120px",
		justifyContent: "center",
	},
	containerTitleCultureText: {
		textTransform: "uppercase",
		marginLeft: "30px",
		marginRight: "30px",
	},
	containerQrcode: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	qrCode: {
		width: "50px",
	},
	qrCodeContainer: {
		paddingTop: 2,
		width: "100%",
		height: "100%",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "flex-start",
		color: "black",
	},
	qrCodeContainerTextSubTitle: {
		fontSize: "30px",
	},
	footer: {
		position: "absolute",
		bottom: 2,
		width: "100%",
		height: "13px",
	},
	containerFooter: {
		width: "100vw",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	paggingContainer: {
		width: "100%",
		backgroundColor: "black",
		height: "10px",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingHorizontal: "2px",
	},
	paggingText: {
		fontSize: "6px",
		fontFamily: "Roboto bold",
		color: "white",
		textAlign: "center",
		flex: 1,
	},
	imgFooterInvetida: {
		height: "8px",
		width: "8px",
		transform: "scaleX(-1)",
	},
	imgFooter: {
		height: "8px",
		width: "8px",
	},
	// textTransform
	TextBoldTitle: {
		fontFamily: "Roboto bold",
		fontSize: "9px",
		textTransform: "uppercase",
	},
	BodyTextBoldTitle: {
		marginTop: 3,
		marginBottom: 3,
		alignItems: "center",
		justifyContent: "center",
	},
	TextBoldSubTitle: {
		fontFamily: "Roboto bold",
		fontSize: "6px",
	},
	TextBoldNumber: {
		fontFamily: "Roboto bold",
		fontSize: "9px",
	},
	TextBold: {
		fontFamily: "Roboto bold",
		fontSize: "5px",
	},
	TextNormal: {
		fontSize: "5px",
		lineHeight: 1.1,
	},
	TextNormalQrCode: {
		fontFamily: "Roboto bold",
		fontSize: "5px",
	},
});

const PdfHangTags = (props) => {
	const vendaItemId = props.item;
	const vendaId = props.venda;
	const [venda, setVenda] = useState(null);
	const [vendaItem, setVendaItem] = useState(null);
	const [loading, setLoading] = useState(true);
	const ids = props.ids;

	const vendaService = new VendaService();

	useEffect(() => {
		initData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const formatCpfCnPJ = (value) => {
		if (value.length > 11) {
			value =
				value.substring(0,2) +
				"." +
				value.substring(2, 5) +
				"." +
				value.substring(5, 8) +
				"/" +
				value.substring(8, 12) +
				"." +
				value.substring(12);
		} else {
			value =
				value.substring(0,3) +
				"." +
				value.substring(3,6) +
				"." +
				value.substring(6,9) +
				"-" +
				value.substring(9);
		}
		return value;
	};

	const initData = async () => {
		try {
			if (!vendaId || !vendaItemId) {
				setLoading(false);
				return;
			}

			const vendaData = await vendaService.getById(vendaId);
			if (!vendaData) {
				setLoading(false);
				return;
			}

			setVenda(vendaData);

			const item = vendaData.itens?.find((i) => i.ordemProducaoId === vendaItemId);
			setVendaItem(item);

			setLoading(false);
		} catch (error) {
			console.error("Erro ao carregar dados da venda:", error);
			setLoading(false);
		}
	};

	const getNomeProduto = (vendaItem) => {
		if (!vendaItem) return "Produto não informado";
		const cultura = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.cultura || "";
		const variedade = vendaItem?.ordemProducao?.produtoFinal?.cultivo?.variedade || "";
		return cultura && variedade
			? `${cultura} ${variedade}`
			: cultura || variedade || "Produto não informado";
	};

	function checkValid() {
		return props.checkDist === "0" ? true : false;
	}

	function checkDoubleTag() {
		return props.doubleTag === "0" ? true : false;
	}

	function QRCodePage({ id }) {
		const qrElement = document.getElementById(id);
		if (!qrElement) {
			return null;
		}
		const dataUrl = qrElement.toDataURL();

		const TagContent = () => (
			<View style={{
				width: "100%",
				height: 103,
				display: "flex",
				flexDirection: "column",
				position: "relative"
			}}>
				<View style={styles.BodyTextBoldTitle}>
					<Text style={styles.TextBoldTitle}>
						{getNomeProduto(vendaItem)}
					</Text>
				</View>
				<View style={[styles.body, {paddingBottom: "15px", height: "75px", overflow: "hidden"}]}>
					<View style={styles.qrCodeContainer}>
						<View style={{width: "70%"}}>
							<View style={styles.containerTitleText}>
								<Text style={styles.TextBoldSubTitle}>
									Peso Líquido Mínimo: <Text style ={styles.TextBoldNumber}>{`${vendaItem?.ordemProducao?.embalagemProdutoFinal?.quantidade || "-"} ${vendaItem?.ordemProducao?.embalagemProdutoFinal?.unidadeMedida?.sigla || ""}`}</Text>
								</Text>
								<Text style={[styles.TextBold, {fontSize: 4.5}]}>Código de Rastreio: {`${venda?.numeroVenda || "-"}-${vendaItem?.ordemProducao?.loteRastreabilidade || "-"}`}</Text>
							</View>
							<View style={styles.containerText}>
								<Text style={styles.TextNormal}>Distribuído por: {venda?.unidadeDistribuidora?.nome || "Não informado"}</Text>
								<Text style={styles.TextNormal}>
									{venda?.unidadeDistribuidora?.cpf_cnpj ?
										(venda.unidadeDistribuidora.cpf_cnpj.length > 11
											? `CNPJ: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`
											: `CPF: ${formatCpfCnPJ(venda.unidadeDistribuidora.cpf_cnpj)}`)
										: ""}
								</Text>
								<Text style={styles.TextNormal}>
									{venda?.unidadeDistribuidora?.endereco ?
										[(venda.unidadeDistribuidora.endereco.logradouro || venda.unidadeDistribuidora.endereco.endereco), venda.unidadeDistribuidora.endereco.bairro, [venda.unidadeDistribuidora.endereco.cidade, venda.unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ")
										: ""}
								</Text>
							</View>
							{checkValid() && (
								<View style={styles.containerText}>
									<Text style={styles.TextNormal}>
										Distribuídor por: {venda?.cliente?.nome || venda?.cliente?.nomeFantasia}
									</Text>
									<Text style={styles.TextNormal}>
										{venda?.cliente?.cpfCnpj && (venda.cliente.cpfCnpj.length > 11
												? `CNPJ: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`
												: `CPF: ${formatCpfCnPJ(venda?.cliente?.cpfCnpj)}`)}
									</Text>
									<Text style={styles.TextNormal}>
										{venda?.cliente?.endereco ? [(venda.cliente.endereco.logradouro || venda.cliente.endereco.endereco), venda.cliente.endereco.bairro, [venda.cliente.endereco.cidade, venda.cliente.endereco.uf].filter(Boolean).join(" - ")].filter(Boolean).join(", ") : ""}
									</Text>
								</View>
							)}
							<View style={styles.containerText}>
								{vendaItem?.ordemProducao?.dataProducao && (
									<Text style={styles.TextNormal}>
										Data de Embalagem: {new Date(vendaItem?.ordemProducao?.dataProducao).toLocaleDateString("pt-BR")}
									</Text>
								)}

								<Text style={styles.TextNormal}>
									Data de Entrega: {new Date(venda?.dataExpedicao).toLocaleDateString("pt-BR")}
								</Text>

								{(vendaItem?.ordemProducao?.dataValidade && props.showExpiryDate) && (
									<Text style={styles.TextNormal}>
										Data de Validade: {new Date(vendaItem?.ordemProducao?.dataValidade).toLocaleDateString("pt-BR")}
									</Text>
								)}
							</View>
						</View>
						{/* lado direito da etiqueta */}
						<View style={styles.containerQrcode}>
							<Text style={[styles.TextNormalQrCode, {textAlign: "center", marginBottom: 2}]}>CONHEÇA ORIGEM DESTE PRODUTO</Text>
							<Image src={dataUrl} style={styles.qrCode} />
						</View>
					</View>
				</View>
				{/* roda pé  */}
				<View style={styles.footer}>
					<View style={styles.paggingContainer}>
						<Image src={Seta} style={styles.imgFooter} />
						<Text style={styles.paggingText}>ORIGEM RASTREADA</Text>
						<Image src={Seta} style={styles.imgFooterInvetida} />
						<Text style={styles.paggingText}>sisagri.com.br</Text>
						<Image src={Seta} style={styles.imgFooterInvetida} />
					</View>
				</View>
			</View>
		);

		return (
			<Page
				key={`page_${id}`}
				size={{ width: 170, height: checkDoubleTag() ? 225.8 : 103 }}
				style={styles.page}
			>
				<TagContent />
				{checkDoubleTag() && (
					<>
						{/* Espaçamento de 0.7cm entre as etiquetas */}
						<View style={{height: 19.8, backgroundColor: "transparent"}} />
						<TagContent />
					</>
				)}
			</Page>
		);
	}

	return (
		!loading && venda && vendaItem && ids && ids.length > 0 ?
			<Document>
				{ids.map((id) => (
					<QRCodePage id={id} key={id} />
				))}
			</Document>
			:<Document></Document>
	);
};

export default PdfHangTags;
